/**
 * Cork Supply Ignore List Manager
 * Gerencia a lista de nomes a serem ignorados (internos da Cork Supply)
 */

import Papa from 'papaparse';

// Cache global da lista de nomes
let corkSupplyIgnoreList = [];
let isListLoaded = false;

/**
 * Carrega a lista de nomes a ignorar do arquivo CSV
 * @returns {Promise<string[]>} Array com os nomes normalizados (lowercase)
 */
export async function loadIgnoreList() {
  if (isListLoaded && corkSupplyIgnoreList.length > 0) {
    console.log('📋 Lista de ignorados já carregada do cache:', corkSupplyIgnoreList.length, 'nomes');
    return corkSupplyIgnoreList;
  }

  try {
    console.log('📥 Carregando lista de nomes a ignorar do CSV...');
    
    const response = await fetch('/cork_supply_ignore_list.csv');
    if (!response.ok) {
      throw new Error(`Erro ao carregar CSV: ${response.status} ${response.statusText}`);
    }
    
    const csvText = await response.text();
    
    return new Promise((resolve, reject) => {
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          try {
            // Extrai os nomes da coluna 'Nome' e normaliza
            corkSupplyIgnoreList = results.data
              .map(row => row.Nome || row.nome || '')
              .filter(name => name.trim() !== '')
              .map(name => name.toLowerCase().trim());
            
            isListLoaded = true;
            console.log('✅ Lista carregada com sucesso:', corkSupplyIgnoreList.length, 'nomes');
            console.log('📋 Primeiros nomes:', corkSupplyIgnoreList.slice(0, 5));
            resolve(corkSupplyIgnoreList);
          } catch (error) {
            console.error('❌ Erro ao processar CSV:', error);
            reject(error);
          }
        },
        error: (error) => {
          console.error('❌ Erro ao fazer parse do CSV:', error);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('❌ Erro ao carregar lista de ignorados:', error);
    // Fallback: retorna lista vazia se não conseguir carregar
    isListLoaded = true;
    corkSupplyIgnoreList = [];
    return corkSupplyIgnoreList;
  }
}

/**
 * Verifica se um nome deve ser ignorado (é da Cork Supply)
 * @param {string} text - Nome a verificar
 * @returns {boolean} true se deve ignorar, false caso contrário
 */
export function isCorkSupplyName(text) {
  if (!text || text === 'N/A') return true;
  
  const normalized = text.toLowerCase().trim();
  
  // Verifica se contém "cork supply"
  if (normalized.includes('cork supply') || normalized.includes('bright up')) return true;
  
  // Verifica se está na lista carregada
  return corkSupplyIgnoreList.includes(normalized);
}

/**
 * Obtém a lista atual de nomes ignorados (para debug)
 * @returns {string[]} Array com os nomes
 */
export function getIgnoreList() {
  return [...corkSupplyIgnoreList];
}

/**
 * Força o recarregamento da lista
 */
export function reloadIgnoreList() {
  isListLoaded = false;
  corkSupplyIgnoreList = [];
  return loadIgnoreList();
}
